import React, { useContext } from 'react'
import { isEmpty } from 'lodash'
import { OverlayContext } from '../../../../contexts'

// Components
import IndicatorContainer from '../IndicatorContainer'
import { Feedback, DisclaimerButton, If, Fade } from '../../../../components'
import SavingsTile from './Tiles/SavingsTile'
import MonthlyCostTile from './Tiles/MonthlyCostTile'
import EmptyOverviewPanel from './EmptyOverviewPanel'
import ToDo from './ToDo'

// Hooks
import {
  useBuyerSettingsWithDefaults,
  useBuyerSettings,
} from '../../../../hooks/buyerSettings'
import { useChromeBotUpdatedProfileSettingsClientEvents } from '../../../../hooks/clientEvents'
import { useListingDisplay } from '../../../../hooks/listing'

// Constants
import { PANEL_IDS } from '../../../../constants/overlayPanels'
import { GUEST_CLIENT_TYPE } from '../../../../constants/buyerSettings'

// Styles
import styles from './OverviewPanel.module.scss'

const OverviewPanel = () => {
  const { handleAddOverlay } = useContext(OverlayContext)
  const { monthlyCost } = useListingDisplay()
  const { maxBudget } = useBuyerSettingsWithDefaults()
  const { data } = useChromeBotUpdatedProfileSettingsClientEvents()
  const { clientType, hasUpdatedListingsBotProfile } = useBuyerSettings()

  const notGuest = clientType !== GUEST_CLIENT_TYPE
  const budgetDiff = monthlyCost - maxBudget

  return (
    <>
      {hasUpdatedListingsBotProfile && (
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.tileContainer}>
              <MonthlyCostTile
                budgetDiff={budgetDiff}
                monthlyCost={monthlyCost}
              />
              <SavingsTile />
            </div>
            <Fade show={isEmpty(data)}>
              <ToDo />
            </Fade>
          </div>
          <IndicatorContainer />
          <DisclaimerButton
            onClick={() => handleAddOverlay(PANEL_IDS.DISCLAIMER)}
            className={styles.link}
          >
            View Disclaimers
          </DisclaimerButton>
          <div className={styles.feedback}>
            <If condition={notGuest}>
              <Feedback />
            </If>
          </div>
        </div>
      )}
      {!hasUpdatedListingsBotProfile && <EmptyOverviewPanel />}
    </>
  )
}
export default OverviewPanel
